import { Component, EventEmitter, Output } from '@angular/core';


/**
 * Component that will display a form with email that you must complete to access the customer overview
 */
@Component({
  selector: 'app-customer-duplicate-message',
  templateUrl: './customer-duplicate-message.component.html'
})
export class CustomerDuplicateMessageComponent {
  @Output() activateClicked: EventEmitter<any> = new EventEmitter<any>(null);
  @Output() newEmailClicked: EventEmitter<any> = new EventEmitter<any>(null);
  public opened: boolean = true;
  public translatedString: string = $localize`:@@customerOverview.notification.customerDuplicateNotification2:You can either |activate the email| on this customer or alternatively |enter a new email address|`;

  constructor() { }

  /**
   * Toggles the opened class
   */
  close(): void {
    this.opened = false;
  }

  /**
   * Sends the click signal to begin the process of activating the user
   */
  public activate(): void {
    this.activateClicked.emit('click');
  }

  /**
   * Sends the click signal to open the communication data form in order to add a new email
   */
  public newEmail(): void {
    this.newEmailClicked.emit('click');
  }

}
